// extracted by mini-css-extract-plugin
export default {"break":"UserInfoForm_break__0OLKy"};